import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ProductParameterFormatImageState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ProductParameterFormatImageQuery extends QueryEntity<ProductParameterFormatImageState> {

  constructor(protected store: Store) {
    super(store);
  }

}
